const mobile_listener = config => {
    // note: android uses JavascriptBridge, iOS uses webkit
    if (window && (window.JavascriptBridge || window.webkit)) {

        // helper function : for throttled resize and orientation change events.
        function OnResize (callback) {
            // on resize
            if ('onorientationchange' in window) {
                window.addEventListener('onorientationchange', function () {
                    trigger();
                    setTimeout(function () {
                        trigger();
                    }, 800);
                }, false);
            }

            // on orientation change
            if ('onresize' in window) {
                window.addEventListener('onresize', function () {
                    trigger();
                    setTimeout(function () {
                        trigger();
                    }, 200);
                }, false);
            }

            // only trigger once every 100ms ヽ(ಠ_ಠ)ノ
            var timeout;
            function trigger () {
                clearTimeout (timeout);
                timeout = setTimeout (function () {
                    callback();
                }, 100);
            }
        };

        // LET'S BEGIN:
        var currentHeight;

        function emitEvent(evt, msg) {
            if (window && window.JavascriptBridge) {
                console.log ('window.JavascriptBridge:', evt, msg);
                window.JavascriptBridge[evt](msg);
            } else if (window && window.webkit) {
                console.log ('window.webkit:', evt, msg);
                window.webkit.messageHandlers[evt].postMessage(msg);
            } else {
                console.log ('[simulate] window.webkit', evt, msg);
            }
        }

        function sendHeight () {
            var height = document.body.scrollHeight;
            if (currentHeight !== height) {
                emitEvent('updateHeight', height);
                currentHeight = height;
            }
        }

        function sendLoaded () {
            sendHeight();
            OnResize(sendHeight);
            setInterval(sendHeight, 100);
            emitEvent('loadingComplete', true);
        }

        emitEvent('setAllowedLinks', config.allowed_urls || []);
        emitEvent('setBlockInteraction', (config.block_interaction === true));

        window.addEventListener('load', function () {
            if (config.load_delay) {
                setTimeout(function () {
                    sendLoaded()
                }, config.load_delay);
            } else {
                sendLoaded()
            }
        });
    }
};

const config = {
    block_interaction: false,
    allowed_urls: [],
    load_delay: 250
};

// export default () => mobile_listener(config);
mobile_listener(config);
